<div id="commonCarousel" class="carousel slide h-100" data-ride="carousel">
  <div class="carousel-inner h-100">
    <drag-scroll
      appHorizontalUserScroll
      (nearEndReached)="onNearEndReached()"
      (indexChanged)="checkIndex($event)"
      #commonCarousel
    >
      @for (item of carouselData; track item) {
      <div
        drag-scroll-item
        class="drag-scroll-item h-100"
        style="margin-right: 0.9rem"
        [ngStyle]="{
          width: carouselData.length === 1 ? '100%' : carouselItemWidth + carouselItemWidthUnit,
        }"
        [class.disabled]="isDisabled && uniqueId === item?.id"
      >
        <div
          class="pointer-events-none"
          (click)="viewDetails(item)"
          [ngStyle]="{
            height: carouselItemHeight ?? 'auto',
            overflow: carouselItemHeight ? 'hidden' : 'visible',
          }"
          [innerHTML]="createTemplateData(item, $index) | safeHtml"
        ></div>
      </div>
      }
    </drag-scroll>
  </div>
</div>
